import { useTranslate } from "@similarweb/i18n-provider";

import { EmployeeProfileConfirmationModal } from "../EmployeeProfileConfirmationModal/EmployeeProfileConfirmationModal";

type DeleteEmployeeProfileModalProps = {
    isOpen: boolean;
    isShared: boolean;
    profileName: string;
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const DeleteEmployeeProfileModal = ({
    isOpen,
    isShared,
    profileName,
    isDeleting,
    onCancel,
    onConfirm,
}: DeleteEmployeeProfileModalProps) => {
    const { translate } = useTranslate();

    const descriptionKey = isShared
        ? "si.employee-profiles.delete.shared.confirmation"
        : "si.employee-profiles.delete.confirmation";

    return (
        <EmployeeProfileConfirmationModal
            isOpen={isOpen}
            titleKey={isShared ? "si.employee-profiles.delete.shared.title" : "si.employee-profiles.delete.title"}
            description={
                <span
                    dangerouslySetInnerHTML={{
                        __html: translate(descriptionKey, { name: profileName }),
                    }}
                />
            }
            confirmLabel={translate(
                isShared ? "si.employee-profiles.delete.shared.confirm" : "si.common.button.delete",
            )}
            confirmButtonType="warning"
            isLoading={isDeleting}
            onCancel={onCancel}
            onConfirm={onConfirm}
            dataAutomation="delete-employee-profile-modal"
        />
    );
};
